import { render, staticRenderFns } from "./StockRequestDraftRow.vue?vue&type=template&id=960aa320"
import script from "./StockRequestDraftRow.vue?vue&type=script&lang=js"
export * from "./StockRequestDraftRow.vue?vue&type=script&lang=js"
import style0 from "./StockRequestDraftRow.vue?vue&type=style&index=0&id=960aa320&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports